<template>
  <IQOS 
    :title="$t('worker_profile.tips_card_title')" 
    :class="{
        'iqos-transparent': !is_active
    }"
    :readonly="false">
    <div class="card-number-group" v-if="is_active">
        <BaseInput 
            :readonly="false"
            placeholder="5168 1111 2222 3333"
            :mask="'#### #### #### ####'"
            v-model="card_number"
            @blur="onEditFinish"
            :valid="!!card_number ? valid || card_number.length >= 19 : true"/>
        <img src="/icons/ms-card.svg">
        <img src="/icons/visa-card.svg">
    </div>  
    <p :class="{
        'comment c-grey': true
    }" v-if="is_active"
        v-html="$t('worker_profile.tips_card_input')">
        
    </p>
    <p :class="{
        'comment c-grey': true,
        'pt-0': !is_active
    }" 
        v-html="$t('worker_profile.tips_card_desc')">
        
    </p>
    <IQOSToggle v-model="is_active"/>
    <!-- <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" /> -->
  </IQOS>
</template>

<script>
import IQOS from '@/components/IQOS.vue'
import BlackInput from '@/components/BlackInput.vue'
import IQOSActions from '@/components/IQOSActions.vue'
import IQOSToggle from "@/components/IQOSToggle.vue"

export default {
    props: {
        waiter: Object
    },
    data() {
        return {
            card_number: null,
            editing: false,
            is_active: false,



            valid: true
        }
    },
    methods: {
        showEditUI() {
            this.editing = true;
        },
        hideEditUI() {
            this.editing = false;
            this.reset();
        },
        reset() {
            this.card_number = this.waiter.tips_card_number || null;

            if (this.card_number) this.is_active = true;  
        },
        onEditFinish() {
            if (this.card_number && this.card_number.length < 19) {
                this.valid = false;
                return;
            }

            this.valid = true;

            this.$emit('saved', this.card_number)
            // this.editing = false;
        }
    },  
    mounted() {
        this.reset();
    },
    components: {
        IQOS,
        IQOSActions,
        BlackInput,
        IQOSToggle
    }
}
</script>

<style>
.card-number-group {
    display: flex;
}

.card-number-group img {
    margin-left: 1.70vh;
}
</style>